import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../index.css'; // 👈 Update path based on your folder structure

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="notfound-container">
      <h1 className="notfound-heading">404</h1>
      <p className="notfound-message">Oops! The page you're looking for doesn't exist.</p>
      <p className="notfound-subtext">Redirecting you to Home...</p>
      <Link to="/" className="notfound-link">Click here if not redirected</Link>
    </div>
  );
}
